export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/lt.e98b2e1f.svg","height":480,"width":640,"blurWidth":0,"blurHeight":0};